const main = document.querySelector("#content-wrapper");
const footer = document.querySelector("footer");

const newsletter = footer.querySelector(".container.footer-newsletter");
main.appendChild(newsletter);

document.querySelector(
  ".subscribe-form.compact-form .form-control"
).placeholder = "Zadejte svou e-mailovou adresu";

document.querySelectorAll(".product .flags").forEach((flag) => {
  //flag.remove()
});

document.querySelector(".newsletter-header").innerHTML = `
<h5 class="boxintro" _msttexthash="4663802" _msthash="244">Zadejte svou e-mailovou adresu, pokud chcete dostávat informace o novinkách a akcích.</h5>
`;

const product_detail = document.querySelector(".p-detail");
if (product_detail) {
  const product_header = product_detail.querySelector(".p-detail-inner-header");
  product_detail.querySelector(".p-image-wrapper").prepend(product_header);

  const product_basic_info_block = product_detail.querySelector(
    ".p-basic-info-block"
  );
  const product_basic_info_new_block = document.createElement("div");
  product_basic_info_new_block.classList.add("block");
  product_basic_info_new_block.innerHTML = `
  <span style="font-weight: 700">Cena: </span>
  `;

  product_basic_info_block.appendChild(product_basic_info_new_block);
  product_basic_info_new_block.appendChild(
    product_detail.querySelector(".price-final-holder")
  );

  const product_basic_info_new_availability_label =
    document.createElement("span");
  product_basic_info_new_availability_label.style.fontWeight = "700";
  product_basic_info_new_availability_label.innerHTML = `
  Dostupnost:
  `;
  const product_basic_info_first_block = product_basic_info_block.querySelector(
    ".p-basic-info-block .block:nth-child(1)"
  );
  product_basic_info_first_block.innerHTML = `
  <div>
  ${product_basic_info_first_block.innerHTML}
  </div>
  `;
  product_basic_info_block
    .querySelector(".p-basic-info-block .block:nth-child(1)")
    .prepend(product_basic_info_new_availability_label);

  const product_data_wrapper = product_detail.querySelector(".p-data-wrapper");
  const product_data_wrapper_wrapper = document.createElement("div");
  product_data_wrapper_wrapper.classList.add("product-data-wrapper-wrapper");
  product_data_wrapper.appendChild(product_data_wrapper_wrapper);

  const product_data_wrapper_wrapper_wrapper = document.createElement("div");
  product_data_wrapper_wrapper_wrapper.classList.add(
    "product-data-wrapper-wrapper-wrapper"
  );
  product_data_wrapper_wrapper.appendChild(
    product_data_wrapper_wrapper_wrapper
  );

  const product_basic_info_manufacturer_block =
    product_basic_info_block.querySelector(
      ".p-basic-info-block .block:nth-child(3)"
    );
  product_basic_info_manufacturer_block.querySelector(
    ".p-manufacturer-label"
  ).innerHTML = "Výrobce:";
  product_data_wrapper_wrapper_wrapper.appendChild(
    product_basic_info_manufacturer_block
  );

  const product_basic_info_code_block = product_basic_info_block.querySelector(
    ".p-basic-info-block .block:nth-child(2)"
  );
  product_basic_info_code_block.querySelector(".p-code-label").innerHTML =
    "Kód produktu:";
  product_data_wrapper_wrapper_wrapper.appendChild(
    product_basic_info_code_block
  );

  const product_param_block = product_detail.querySelector(".p-param-block");
  const product_shop_tabs = product_detail.querySelector(
    ".shp-tabs-wrapper.p-detail-tabs-wrapper"
  );
  const product_param_block_title = document.createElement("h2");
  product_param_block.classList.add("row");
  product_param_block.classList.remove("p-param-block");
  product_param_block.innerHTML = `
  <div class="p-param-block">
  ${product_param_block.innerHTML}
  </div>
  `;
  product_param_block_title.innerHTML = `
  Technické údaje
  `;
  product_param_block.prepend(product_param_block_title);
  product_shop_tabs.appendChild(product_param_block);

  const product_chat = product_detail.querySelector(".link-icon.chat");
  product_data_wrapper_wrapper.appendChild(product_chat);
}

if (false) {
  setTimeout(() => {
    const dialog = document.createElement("div");
    document.body.appendChild(dialog);
    dialog.innerHTML = `
<div class="wce_popup-consolidator wce_popup-active" style="opacity: 1">
  <a class="wce_popup-consolidator-close wce_none"><span>×</span></a>
  <style data-wce-popup-styles-for="wce_overlay-popup-wcePopup_7623" data-test="">
    #wce_overlay-popup-wcePopup_7623 {
      --popupWidth: 500px;
      --popupProportion: calc((500 / 500) * 100%);
    }
    body {
      /* none */
    }
  </style>
  <template
    data-wce-popup-template-id="wce_overlay-popup-wcePopup_7623"
    class="wceapp_popup wceapp_wtype-3 wceapp_ctype-6 wceapp_popup-rbasket wceapp_popup-l-a"
    data-ck="wcePopup_7623"
    data-locale="pl_PL"
    data-interval="2"
    data-delay="0"
    data-priority="1"
    data-popup-blurr-body="1"
  >
    <div
      style="display: none"
      id="wce_overlay-popup-wcePopup_7623"
      class="wce_overlay-popup wceapp_popup wceapp_wtype-3 wceapp_ctype-6 wceapp_popup-rbasket wceapp_popup-l-a"
      data-window-type="exit"
      data-content-type="basket"
      data-ck="wcePopup_7623"
      data-locale="pl_PL"
      data-interval="2"
      data-delay="0"
      data-priority="1"
      data-popup-blurr-body="1"
    >
      <aside class="wce_popup" style="width: var(--popupWidth)">
        <div class="wce_popup-head">
          <strong class="wce_popup-head-text"> Produkty w koszyku </strong>
          <a class="wce_popup-close"> <span>×</span> </a>
        </div>
        <div class="wce_popup-body">
          <div
            class="wce_popup-body-proportion"
            style="padding-bottom: var(--popupProportion)"
          ></div>
          <div class="wce_popup-body-frame">
            <div class="wce_popup-basket-content">
              <div class="resetcss">
                <p>Chyba o czymś zapomniałeś.</p>
                <p>Dokończ zakupy.</p>
              </div>
              <div class="wce_popup-products-wrap">
                <div class="wce_popup-products wce_loading"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="wce_popup-footer wce_popup-basket-footer">
          <a class="btn wce_popup-close">nie, dzięki</a>
          <a class="btn btn-red wce_popup-close wce_goto-basket">Chcę dokończyć zakupy</a>
        </div>
      </aside>
      <a class="wce_popup-close wce_popup-close-overlay"></a>
    </div>
  </template>
  <style data-wce-popup-styles-for="wce_overlay-popup-wcePopup_7870" data-test="0">
    #wce_overlay-popup-wcePopup_7870 {
      --popupWidth: 600px;
      --popupProportion: calc((600 / 600) * 100%);
    }
    body {
      /* none */
    }
  </style>
  <template
    data-wce-popup-template-id="wce_overlay-popup-wcePopup_7870"
    class="wceapp_popup wceapp_wtype-1 wceapp_ctype-3 wceapp_popup-l-mp wceapp_popup-l-ca"
    data-ck="wcePopup_7870"
    data-locale="pl_PL"
    data-interval="2"
    data-delay="2000"
    data-priority="1"
  >
    <div
      style="display: none"
      id="wce_overlay-popup-wcePopup_7870"
      class="wce_overlay-popup wceapp_popup wceapp_wtype-1 wceapp_ctype-3 wceapp_popup-l-mp wceapp_popup-l-ca"
      data-window-type="normal"
      data-content-type="image"
      data-ck="wcePopup_7870"
      data-locale="pl_PL"
      data-interval="2"
      data-delay="2000"
      data-priority="1"
    >
      <aside class="wce_popup" style="width: var(--popupWidth)">
        <div class="wce_popup-head">
          <a class="wce_popup-close"> <span>×</span> </a>
        </div>
        <div class="wce_popup-body">
          <div
            class="wce_popup-body-proportion"
            style="padding-bottom: var(--popupProportion)"
          ></div>
          <a class="wce_popup-body-image" href="https://keter.pl/signature">
            <img
              src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D"
              data-image-url="https://sklep377994.shoparena.pl/userdata/public/assets//keer_popup_signature.png"
              alt="SIGNATURE"
            />
          </a>
        </div>
      </aside>
      <a class="wce_popup-close wce_popup-close-overlay"></a>
    </div>
  </template>
  <div
    style=""
    id="wce_overlay-popup-wcePopup_7870"
    class="wce_overlay-popup wceapp_popup wceapp_wtype-1 wceapp_ctype-3 wceapp_popup-l-mp wceapp_popup-l-ca wce_is-displaying"
    data-window-type="normal"
    data-content-type="image"
    data-ck="wcePopup_7870"
    data-locale="pl_PL"
    data-interval="2"
    data-delay="2000"
    data-priority="1"
  >
    <aside class="wce_popup wce_display-in" style="width: var(--popupWidth); display: block">
      <div class="wce_popup-head">
        <a class="wce_popup-close"> <span>×</span> </a>
      </div>
      <div class="wce_popup-body">
        <div
          class="wce_popup-body-proportion"
          style="padding-bottom: var(--popupProportion)"
        ></div>
        <a class="wce_popup-body-image" href="https://keter.pl/signature">
          <img
            src="https://sklep377994.shoparena.pl/userdata/public/assets//keer_popup_signature.png"
            data-image-url="https://sklep377994.shoparena.pl/userdata/public/assets//keer_popup_signature.png"
            alt="SIGNATURE"
            class="wce_loaded"
          />
        </a>
      </div>
    </aside>
    <a class="wce_popup-close wce_popup-close-overlay"></a>
  </div>
</div>
  `;

    dialog.querySelectorAll(".wce_popup-close").forEach((close) => {
      close.addEventListener("click", () => {
        dialog.remove();

        // save to cookie
        document.cookie =
          "wce_popup-consolidator=1; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
      });
    });
  }, 1000);
}
